<template>
  <div ref="chartWrapper"
       class="widget-wrapper"
  >
    <div class="widget-contents">
      <div class="widget-contents-wrapper">
        <trend-chart ref="chartInstance"
                     class="widget-contents-chart"
                     :grid="{ left: '1%', right: '1%'}"
                     :data="widgetData"
                     :x-axis="xAxis"
                     :y-axis="yAxis"
                     :series="series"
                     :tooltip="tooltip"
                     :zoom="true"
        />
      </div>
    </div>
  </div>
</template>
<script>
  // import Moment from 'moment'
  // Mixin 객체
  import {widgetMixin} from '~/mixins/widgetCommonMixin'
  // 차트 컴포넌트
  import {top10Color} from '~/utils/charts'
  // 스토어 헬퍼
  import {createNamespacedHelpers} from 'vuex'
  // 스토어 헬퍼 객체
  const {mapGetters} = createNamespacedHelpers('common/common/')
  const {mapActions} = createNamespacedHelpers('dashboard/dashboard')

  export default {
    name: 'widgetTrfAptSessionCntTrend',
    mixins: [widgetMixin],
    data () {
      return {
        w: 2,
        self: this,
        title: 'widgetTrfAptSessionCntTrend',
        isLock: false,
        isMove: true,
        isResize: true,
        eventBus: true,
        deviceType: [21],
        allUpdate: true, // false,
        restData: {
          result: [],
          unit_time: ''
        },
        widgetData: [],
        timerValue: 10000,
        timerObject: null,
        lastEndTime: '',
        xAxisRawData: {
          type: 'time',
          axisLine: {onZero: true},
          axisLabel: {
            formatter: '{HH}:{mm}:{ss}  ',
            hideOverlap: true
          }
        },
        yAxisRawData: [{
          max: 1,
          min: -1,
          type: 'value',
          axisLabel: {
            formatter: value => this.kmgtConverter(value)
          }
        }],
        // TAMS
        autoAlignTimer: void 0
      }
    },
    computed: {
      ...mapGetters([
        'getDeviceTime'
      ]),
      xAxis: {
        get () { return this.xAxisRawData },
        set (options) { this.xAxisRawData = options }
      },
      yAxis: {
        get () { return this.yAxisRawData },
        set (options) { this.yAxisRawData = options }
      },
      series: function () {
        return [
          { id: 'aptSessionCnt', type: 'line', name: `APT ${this.$t('dash.widgetCommonSessions')}`, smooth: 0.6, lineStyle: {width: 1}, areaStyle: { color: top10Color[0] }, symbol: 'circle', showSymbol: false, triggerLineEvent: true }
        ]
      },
      tooltip () {
        return {
          axisPointer: {type: 'line'},
          formatter: (params) => {
            let resFormat = `<b>${params[0].axisValueLabel.split(' ')[1]}</b><br>`
            for (let i = 0, max = params.length; i < max; i++) {
              const cnt = Math.abs(params[i].value[1])
              const seriesName = `APT ${this.$t('dash.widgetCommonSessions')}`
              resFormat += `${params[i].marker}${seriesName} : <b>${this.kmgtConverter(cnt)}${this.restData.unit_time}</b><br>`
            }
            return resFormat
          }
        }
      }
    },
    beforeCreate () {},
    created () {},
    beforeMount () {},
    mounted () {
      // 타이머 객체 생성
      // this.timerObject = setInterval(this.getWidgetContentsData, this.timerValue)
    },
    beforeUpdate () {},
    updated () {},
    activated () {},
    deactivated () {},
    beforeDestroy () {
      // 랜더링 이후 차트 중앙정렬 타이머
      if (this.autoAlignTimer) {
        clearTimeout(this.autoAlignTimer)
      }

      // 셀프 객체 초기화
      this.self = null
    },
    destroyed () {},
    errorCaptured () {},
    methods: {
      ...mapActions([
        'getWidgetData'
      ]),
      // 위젯 대상 장비 필터 설정.
      async onChangeWidgetMachId ({ machId }) {
        // 위젯 옵션 변경 - 저장에 필요한 값???
        this.opts.mach_id = machId
        this.getWidgetContentsData(true, machId)
      },
      async getWidgetContentsData (init = false, extraParams = null) {
        const contentsOptions = {
          widgetType: 'apt_session_trend'
        }

        // 장비 filter 추가
        if (this.opts.mach_id) {
          contentsOptions.machId = this.opts.mach_id
        }

        // 엑스트라 파라미터가 있는 경우 (Device Filter를 선택하여 데이터를 다시 불러와야 하는 경우)
        if (extraParams && extraParams.machId) {
          contentsOptions.machId = extraParams.machId
        }

        /*
          - 한시간 데이터 초기화 시 (실시간 추이 데이터)
            현재 장비시간의 -30초 ~ 1시간 이전 데이터 호출
        */
        // 삭제 예정
        // if (!init && this.lastEndTime !== '') {
        //   // 마지막 요청 시간을 시작 시간으로 설정 (14:05:00)
        //   const sTime = Moment(this.lastEndTime).add(1, 'seconds')
        //
        //   // 1초 더한 시간을 시작 시간으로 추가 (14:05:00)
        //   contentsOptions.sTime = sTime.format('YYYY-MM-DD HH:mm:ss')
        //
        //   // 시작시간 + 9초를 끝시간으로 추가 (14:05:00 ~ 14:05:09)
        //   contentsOptions.eTime = Moment(sTime).add(9, 'seconds').format('YYYY-MM-DD HH:mm:ss')
        // } else {
        //   // 실시간 위젯은 위젯 데이터를 30초를 뺀 시간을 기준으로 한다. (Ex. 14:05:37초일 경우 기본 계산 시간은 14:05:07초)
        //   const calcBaseTime = Moment(this.getDeviceTime).subtract(30, 'seconds')
        //
        //   // 계산된 시간에서 1초 단위를 초기화. (14:05:00)
        //   const endTime = calcBaseTime.seconds(this.floorSecondTime(calcBaseTime.seconds()))
        //
        //   // 계산된 endTime에서 1시간 빼기. (13:05:00)
        //   const startTime = _.cloneDeep(endTime).subtract(1, 'hours')
        //
        //   // endTime에서 1초 빼기 (14:04:59)
        //   contentsOptions.eTime = endTime.subtract(1, 'seconds').format('YYYY-MM-DD HH:mm:ss')
        //
        //   // startTime 추가 (13:05:00 ~ 14:04:59로 최초 요청)
        //   contentsOptions.sTime = startTime.format('YYYY-MM-DD HH:mm:ss')
        // }

        // Progress 출력 여부
        this.showProgress(true)

        // initFlag가 True면 기존 차트 데이터 초기
        if (init) {
          // 위젯 데이터 초기화
          this.widgetData = []

          // Series 초기화
          this.$refs.chartInstance.clear()
        }

        // 요청 전 차트 업데이트 처리지정
        // this.allUpdate = init

        // API 호출
        const {code, result} = await this.getWidgetData(contentsOptions)

        // 마지막 시간 저장 (14:04:59 저장)
        // this.lastEndTime = eTime

        // Series 데이터 구성
        if (code === 'ok' && result.result && result.result.length > 0) {
        // if (code === 'ok') {
          // Rest data 초기화
          this.restData = result || {
            result: [],
            unit_time: ''
          }
          let maxVal = 0
          const curSessions = []

          for (const {name: time, value: count} of this.restData.result) {
            maxVal = Math.max(maxVal, count)
            curSessions.push([time, count])
          }

          this.yAxis[0].max = maxVal + (maxVal * 0.3) || 1
          this.widgetData = [curSessions]
        } else {
          // TAMS - All update 기준
          // 위젯 데이터 초기화
          this.widgetData = []

          // Series 초기화
          this.$refs.chartInstance.clear()
        }

        // Progress 출력 여부
        this.showProgress(false)
      }
    },
    watch: {}
  }
</script>
<style scoped>
  .widget-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .widget-contents-option {
    right: 0;
    display: flex;
    padding-top: 5px;
    padding-right: 5px;
    margin-bottom: 5px;
  }

  .widget-contents {
    display: flex;
  }

  .widget-contents-wrapper {
    flex-grow: 1;
    display: flex;
    position: relative;
  }

  .widget-contents-option {
    z-index: 10;
    right: 0;
    display: flex;
    position: absolute;
    padding-top: 5px;
    padding-right: 17px;
    margin-bottom: 5px;
  }

  .widget-contents-chart {
    flex-grow: 1 !important;
  }
</style>
